import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = document.querySelector('.header').offsetHeight;
      const elementPosition = element.offsetTop - headerHeight - 20;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/assets/img/logo1.png" alt="Dr. Sasan Mansouri" />
                <div className="logo-text">
                  <h4>Dr. Sasan Mansouri</h4>
                  <p>Associate Professor of Digitalization & AI</p>
                  <p>University of Groningen</p>
                </div>
              </div>
              <div className="footer-contact">
                <p>Email: s.mansouri@rug.nl</p>
                <p>Phone: +31 50 36 33768</p>
                <p>Office: Duisenberg Building (801)</p>
              </div>
            </div>

            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><button onClick={() => scrollToSection('hero')}>About</button></li>
                <li><button onClick={() => scrollToSection('research')}>Research</button></li>
                <li><button onClick={() => scrollToSection('teaching')}>Teaching</button></li>
                <li><button onClick={() => scrollToSection('entrepreneurship')}>Entrepreneurship</button></li>
                <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Research Areas</h4>
              <ul className="footer-links">
                <li>Financial Data Science</li>
                <li>Machine Learning</li>
                <li>ESG & Sustainability</li>
                <li>Information Intermediaries</li>
                <li>Entrepreneurial Finance</li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-copyright">
              <p>&copy; {currentYear} Dr. Sasan Mansouri. All rights reserved.</p>
            </div>
            <div className="footer-credits">
              <p>
                Built with React & Modern Web Technologies
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Back to Top Button */}
      <button 
        className={`back-to-top ${showBackToTop ? 'visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        <FaArrowUp />
      </button>
    </>
  );
};

export default Footer; 